import { render, staticRenderFns } from "./bo-related-bundle-card.vue?vue&type=template&id=1f63fc60"
import script from "./bo-related-bundle-card.vue?vue&type=script&lang=js"
export * from "./bo-related-bundle-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports